import "../../../styles/SimpleQuizz/DisplayFlower/Couronne.css";
import React from "react";
import logo from "../../../Images/couronne_fixed.png";

export default function Couronne() {
  return (
    <div className="couronne">
      <img src={logo} />
    </div>
  );
}
